import script from "./InstitutionalIdentificationSectionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstitutionalIdentificationSectionView.vue?vue&type=script&setup=true&lang=ts"

import "./InstitutionalIdentificationSectionView.vue?vue&type=style&index=0&id=5fcace95&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fcace95"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
